import { render, staticRenderFns } from "./InvoiceApprovedMemoDetail.vue?vue&type=template&id=20732071&scoped=true&"
import script from "./InvoiceApprovedMemoDetail.vue?vue&type=script&lang=js&"
export * from "./InvoiceApprovedMemoDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20732071",
  null
  
)

export default component.exports